(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    function slUpdateQuantity(input) {
  const selector = input.closest('quantity-selector[data-sl-minimum]');
  if (!selector) return;
  const min = Number(selector.dataset.slMinimum) || 1;
  const value = Number(input.value);
  if (!Number.isInteger(value) || value < min) input.value = String(min);
  const minus = selector.querySelector('button:first-child');
  if (minus) minus.disabled = Number(input.value) <= min;
}
document.addEventListener('change', event => {
  if(event.target.matches('quantity-selector[data-sl-minimum] input')) slUpdateQuantity(event.target);
}, true);
document.addEventListener('click', event => {
  const selector = event.target.closest('quantity-selector[data-sl-minimum]');
  if(selector) queueMicrotask(() => slUpdateQuantity(selector.querySelector('input')));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sl-glue-advice"] && !Shopify.designMode) return;
  try {
    function slGlueRate(description) {
    const source = description.toLowerCase().replace(/\u00a0/g, ' ');
    const pattern = /\b(een|twee|drie|\d+(?:[.,]\d+)?)\s*(?:tubes?|kokers?)\s+(?:[a-z-]+\s+){0,3}per\s*paneel\b/g;
    const words = { een: 1, twee: 2, drie: 3 }, rates = [];
    for (const match of source.matchAll(pattern)) {
      if (/[\d/–—-]\s*$/.test(source.slice(0, match.index))) return null;
      const rate = words[match[1]] || Number(match[1].replace(',', '.'));
      if (!(rate > 0 && rate <= 10)) return null;
      rates.push(rate);
    }
    return rates.length && new Set(rates).size === 1 ? rates[0] : null;
  }
  if (!customElements.get('sl-glue-advice')) {
    customElements.define('sl-glue-advice', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.rate = slGlueRate(this.dataset.description || '');
        this.input = this.querySelector('input[name="quantity"]');
        this.message = this.querySelector('.sl-glue-message');
        this.note = this.querySelector('.sl-glue-note');
        this.listener = event => {
          if (event.target === this.input) this.manual = true;
          if (event.target.form?.getAttribute('id') === this.dataset.formId && event.target.name === 'quantity') this.updateAdvice();
        };
        document.addEventListener('input', this.listener);
        document.addEventListener('change', this.listener);
        this.updateAdvice();
      }
      disconnectedCallback() {
        document.removeEventListener('input', this.listener);
        document.removeEventListener('change', this.listener);
        this.bound = false;
      }
      updateAdvice() {
        const panelInput = document.getElementById(this.dataset.formId)?.elements.namedItem('quantity');
        const panels = Number(panelInput?.value);
        if (!this.rate || !this.input || !Number.isSafeInteger(panels) || panels < 1) return;
        const minimum = Number(this.input.min) || 1, step = Number(this.input.step) || 1;
        const required = minimum + Math.ceil(Math.max(0, Math.ceil(panels * this.rate) - minimum) / step) * step;
        if (!Number.isSafeInteger(required)) return;
        const maximum = Number(this.input.max) || Infinity;
        const available = Math.min(required, minimum + Math.floor((maximum - minimum) / step) * step);
        if (!this.manual && available >= minimum) this.input.value = String(available);
        this.message.textContent = this.dataset.message.replace('[count]', String(required)).replace('[panels]', String(panels));
        this.message.hidden = this.note.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sl-panel-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sl-panel-calculator')) {
    customElements.define('sl-panel-calculator', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.widthInput = this.querySelector('[data-wall-width]');
        this.heightInput = this.querySelector('[data-wall-height]');
        this.result = this.querySelector('.sl-panel-result');
        this.size = this.querySelector('.sl-panel-size');
        this.setDimensions(this.dataset.variantTitle);
        this.addEventListener('input', () => this.calculate());
        this.addEventListener('change', () => this.calculate());
        this.variantListener = event => {
          if (event.target.getAttribute?.('id') !== this.dataset.formId) return;
          this.setDimensions(event.detail?.variant?.title || '');
          this.calculate();
        };
        document.addEventListener('variant:change', this.variantListener);
      }
      disconnectedCallback() { document.removeEventListener('variant:change', this.variantListener); this.bound = false; }
      setDimensions(variantTitle) {
        const source = [variantTitle, this.dataset.title, this.dataset.description].join(' ');
        const match = source.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)(?:\s*[x×]\s*\d+(?:[.,]\d+)?)?\s*(mm|cm|m)?/i);
        if (!match) { this.hidden = true; return; }
        const factor = match[3]?.toLowerCase() === 'mm' ? 1000 : match[3]?.toLowerCase() === 'm' ? 1 : 100;
        const a = Number(match[1].replace(',', '.')) / factor;
        const b = Number(match[2].replace(',', '.')) / factor;
        this.panelHeight = Math.max(a, b);
        this.panelWidth = Math.min(a, b);
        this.hidden = !(this.panelHeight > 0 && this.panelWidth > 0);
        this.size.textContent = `${this.dataset.size}: ${+(this.panelHeight * 100).toFixed(2)} × ${+(this.panelWidth * 100).toFixed(2)} cm`;
      }
      calculate() {
        const number = value => /^\d+(?:[.,]\d+)?$/.test(value.trim()) ? Number(value.trim().replace(',', '.')) : NaN;
        const width = number(this.widthInput.value), height = number(this.heightInput.value);
        if (!(width > 0 && height > 0) || this.hidden) { this.result.textContent = ''; return; }
        let count = Math.ceil(width / this.panelWidth - 1e-9) * Math.ceil(height / this.panelHeight - 1e-9);
        const form = document.getElementById(this.dataset.formId);
        const input = form?.elements.namedItem('quantity');
        if (input) {
          const min = Number(input.min) || 1, step = Number(input.step) || 1;
          count = min + Math.ceil(Math.max(0, count - min) / step) * step;
        }
        if (!Number.isSafeInteger(count) || count < 1) { this.result.textContent = ''; return; }
        this.result.textContent = `${this.dataset.advice}: ${count} ${this.dataset.panels}`;
        if (input) { input.value = String(count); input.dispatchEvent(new Event('input', { bubbles: true })); input.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sl-review-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sl-review-carousel')) {
    customElements.define('sl-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.mountFrame = requestAnimationFrame(() => this.mount());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.mountFrame);
        this.cleanup?.();
      }

      mount() {
        const root = this.closest('.sl-customer-reviews');
        const list = root?.querySelector('.sl-review-grid');
        const originals = list ? Array.from(list.children).filter(el => el.matches('.sl-review-card') && !el.hasAttribute('data-review-copy')) : [];
        if (!list || originals.length < 2 || this.cleanup) return;

        const events = new AbortController();
        const on = (target, name, handler, options = {}) => target.addEventListener(name, handler, { ...options, signal:events.signal });
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const hoverDevice = matchMedia('(hover: hover)');
        const toggle = this.querySelector('[data-review-toggle]');
        let paused = reduced.matches;
        let hovered = false;
        let focused = false;
        let inView = false;
        let cycle = 0;
        let frame = 0;
        let last = 0;
        let position = 0;
        let resizing = 0;

        list.classList.add('sl-review-moving');
        list.id = this.dataset.listId;
        list.tabIndex = 0;
        list.setAttribute('role', 'group');
        list.setAttribute('aria-label', this.dataset.listLabel);
        this.hidden = false;

        const normalize = value => cycle ? ((value % cycle) + cycle) % cycle : 0;
        const running = () => !paused && !reduced.matches && !hovered && !focused && inView && !document.hidden && cycle > 0;
        const tick = now => {
          frame = 0;
          if (!running()) { last = 0; return; }
          const elapsed = last ? Math.min(now - last, 64) : 0;
          last = now;
          position = normalize(position + elapsed * 0.024);
          list.scrollLeft = position;
          frame = requestAnimationFrame(tick);
        };
        const sync = () => {
          const stopped = paused || reduced.matches;
          toggle.textContent = stopped ? this.dataset.playLabel : this.dataset.pauseLabel;
          toggle.hidden = reduced.matches;
          if (running() && !frame) {
            position = normalize(list.scrollLeft);
            last = 0;
            frame = requestAnimationFrame(tick);
          } else if (!running()) {
            cancelAnimationFrame(frame);
            frame = 0;
            last = 0;
          }
        };
        const rebuild = () => {
          cancelAnimationFrame(frame);
          frame = 0;
          list.querySelectorAll('[data-review-copy]').forEach(el => el.remove());
          const gap = parseFloat(getComputedStyle(list).columnGap) || 18;
          const step = originals[0].getBoundingClientRect().width + gap;
          cycle = step * originals.length;
          if (!reduced.matches && cycle > 0) {
            const rounds = Math.max(1, Math.ceil(list.clientWidth / cycle));
            for (let round = 0; round < rounds; round += 1) {
              for (const original of originals) {
                const clone = original.cloneNode(true);
                clone.setAttribute('data-review-copy', '');
                clone.setAttribute('aria-hidden', 'true');
                clone.inert = true;
                clone.removeAttribute('id');
                clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
                list.append(clone);
              }
            }
          }
          position = reduced.matches ? 0 : normalize(list.scrollLeft);
          list.scrollLeft = position;
          sync();
        };
        const pause = () => { paused = true; sync(); };
        const step = direction => {
          pause();
          const gap = parseFloat(getComputedStyle(list).columnGap) || 18;
          const width = originals[0].getBoundingClientRect().width + gap;
          let target = list.scrollLeft + direction * width;
          if (reduced.matches) {
            const max = Math.max(0, list.scrollWidth - list.clientWidth);
            if (target > max + 1) target = 0;
            if (target < -1) target = max;
          } else {
            const current = normalize(list.scrollLeft);
            list.scrollLeft = current;
            target = current + direction * width;
            if (target < 0) { list.scrollLeft = current + cycle; target += cycle; }
          }
          list.scrollTo({ left:target, behavior:reduced.matches ? 'auto' : 'smooth' });
        };

        on(toggle, 'click', () => { paused = !paused; sync(); });
        on(this.querySelector('[data-review-previous]'), 'click', () => step(-1));
        on(this.querySelector('[data-review-next]'), 'click', () => step(1));
        on(list, 'mouseenter', () => { if (hoverDevice.matches) { hovered = true; sync(); } });
        on(list, 'mouseleave', () => { hovered = false; sync(); });
        on(list, 'focusin', () => { focused = true; sync(); });
        on(list, 'focusout', () => { focused = false; sync(); });
        on(list, 'pointerdown', pause, { passive:true });
        on(list, 'wheel', event => { if (Math.abs(event.deltaX) > 0) pause(); }, { passive:true });
        on(list, 'keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); step(event.key === 'ArrowRight' ? 1 : -1); }
        });
        on(document, 'visibilitychange', sync);
        on(reduced, 'change', () => { if (reduced.matches) paused = true; rebuild(); });

        const visible = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; sync(); });
        visible.observe(list);
        const resized = new ResizeObserver(() => { cancelAnimationFrame(resizing); resizing = requestAnimationFrame(rebuild); });
        resized.observe(list);
        rebuild();

        this.cleanup = () => {
          cancelAnimationFrame(frame);
          cancelAnimationFrame(resizing);
          events.abort();
          visible.disconnect();
          resized.disconnect();
          list.querySelectorAll('[data-review-copy]').forEach(el => el.remove());
          list.classList.remove('sl-review-moving');
          this.hidden = true;
          this.cleanup = null;
        };
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
